import React, { useEffect, useState } from "react";
import { Typography, FormControlLabel, FormControl, Checkbox, RadioGroup } from '@mui/material';
import ModalFooter from "../../../Modal/ModalFooter/ModalFooter";

export default function StepSeven(props) {
    const [buttons, setButtons] = useState(
        [
            {
                'function': props.prev,
                'text': 'Précedent',
                'disabled': false,
                'color': 'error'
            },
            {
                'function': props.next,
                'text': 'Suivant',
                'disabled': true,
                'color': 'success'
            }
        ]);

        useEffect(() => {
            if (props.datas.avantages && Object.keys(props.datas.avantages).length >= 1) {
                buttons[1].disabled = false;
            } else {
                buttons[1].disabled = true;
            }
            setButtons([...buttons]);
        }, [props.datas]);

    function handleChange(e){
        let datas = Object.assign({}, props.datas);
        if(!datas.avantages){
            datas.avantages = [];
        }
        let filtered = datas.avantages.filter( data => data != e.target.value);
        if(e.target.checked){
            filtered.push(e.target.value);
        }
        datas.avantages = filtered;
        props.handleChange(datas);
    }

    return (
        <>
            <Typography id="modal-modal-description" variant="p">
            Selon vous, dans l’ensemble, pensez-vous que la « location de logements à court et moyen terme » : (Plusieurs réponses possibles)
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                <FormControl component="fieldset">
                    <RadioGroup
                        aria-label="gender"
                        defaultValue="public"
                        name="radio-buttons-group">
                        <FormControlLabel value="Ne présente aucun avantage" control={<Checkbox name='avantages' onChange={(e) => handleChange(e)}/>} label="Ne présente aucun avantage"/>
                        <FormControlLabel value="Représente une source supplémentaire de revenus pour les citoyens" control={<Checkbox name='avantages' onChange={(e) => handleChange(e)}/>} label="Représente une source supplémentaire de revenus pour les citoyens" />
                        <FormControlLabel value="Constitue une alternative aux offres de logement plus traditionnelles" control={<Checkbox name='avantages' onChange={(e) => handleChange(e)}/>} label="Constitue une alternative aux offres de logement plus traditionnelles" />
                        <FormControlLabel value="Répond à des besoins de logements temporaires non satisfaits [par exemple, pour les touristes à faibles revenus, les familles (nombreuses), les professionels en déplacements pour plusieurs semaines, les personnes sans dossier locatifs recevables…]" control={<Checkbox name='avantages' onChange={(e) => handleChange(e)}/>} label="Répond à des besoins de logements temporaires non satisfaits [par exemple, pour les touristes à faibles revenus, les familles (nombreuses), les professionels en déplacements pour plusieurs semaines, les personnes sans dossier locatifs recevables…]" />
                        <FormControlLabel value="Permet de créer de l’emploi" control={<Checkbox name='avantages' onChange={(e) => handleChange(e)}/>} label="Permet de créer de l’emploi" />
                        <FormControlLabel value="Attire des visiteurs et participe au développement économique de la ville et des commerces" control={<Checkbox name='avantages' onChange={(e) => handleChange(e)}/>} label="Attire des visiteurs et participe au développement économique de la ville et des commerces" />
                        <FormControlLabel value="Renforce de la visibilité de la ville et valorise son image de ville attractive et dynamique" control={<Checkbox name='avantages' onChange={(e) => handleChange(e)}/>} label="Renforce de la visibilité de la ville et valorise son image de ville attractive et dynamique" />
                        <FormControlLabel value="Favorise l’investissement dans les services locaux (par exemple, l’hébergement, le tourisme et les transports)" control={<Checkbox name='avantages' onChange={(e) => handleChange(e)}/>} label="Favorise l’investissement dans les services locaux (par exemple, l’hébergement, le tourisme et les transports)" />
                        <FormControlLabel value="A pour effet de réduire la disponibilité de logements à louer dans les villes" control={<Checkbox name='avantages' onChange={(e) => handleChange(e)}/>} label="A pour effet de réduire la disponibilité de logements à louer dans les villes" />
                        <FormControlLabel value="A pour effet d’améliorer la qualité du parc locatif" control={<Checkbox name='avantages' onChange={(e) => handleChange(e)}/>} label="A pour effet d’améliorer la qualité du parc locatif" />
                        <FormControlLabel value="A des conséquences économiques néfastes pour les prestataires de services d’hébergement traditionnels" control={<Checkbox name='avantages' onChange={(e) => handleChange(e)}/>} label="A des conséquences économiques néfastes pour les prestataires de services d’hébergement traditionnels" />
                        <FormControlLabel value="Répond à un mode de séjour de plus en plus recherché par les voyageurs" control={<Checkbox name='avantages' onChange={(e) => handleChange(e)}/>} label="Répond à un mode de séjour de plus en plus recherché par les voyageurs" />
                        <FormControlLabel value="Et un vrai soutien à l’économie locale" control={<Checkbox name='avantages' onChange={(e) => handleChange(e)}/>} label="Et un vrai soutien à l’économie locale" />
                    </RadioGroup>
                </FormControl>
            </Typography>
            <ModalFooter buttons={buttons}/>
        </>
    )
}